import React from 'react'
import { Box, Button, Container, Typography } from '@mui/material'
import { useAuth0 } from '@auth0/auth0-react'
import { useHistory } from 'react-router-dom';
import useDocumentTitle from '../../hooks/useDocumentTitle';



export const UnauthorizedPage = (props) => {
  const homeButton = props.home ? props.home : false;
  const {isAuthenticated, logout, loginWithRedirect} = useAuth0();
  const history = useHistory();
  useDocumentTitle("Unauthorized");

  return (
    <Container sx={{margin: 'auto', textAlign: 'center'}}>
        <Typography variant="h4">
          {isAuthenticated ? "Unauthorized Access: Please contact Levrum if you believe this to be an error." 
            : "Please Login To View Application"}
        </Typography>
        {homeButton ? 
          <Button variant="contained" onClick={() => history.push("/")}>Home</Button> 
        :
          <Button variant="contained" onClick={isAuthenticated ? logout : loginWithRedirect}>
            {isAuthenticated ? "Logout" : "Login"}
          </Button>
        }
    </Container>
  )
}


